import Flex from 'legacyfrontend/components/Flex';
import { DATE_KEYS } from 'legacyfrontend/constants';
import { formatWithMomentFormat, utcToLocal } from 'legacyfrontend/utils/dateUtils';

const FlightDate = ({ date, location }) => {
  if (!date) {
    return null;
  }

  return (
    <Flex className='package-card__dynamic-content__wrapper__flight-list__records__item__details__date'>
      <span className='package-card__dynamic-content__wrapper__flight-list__records__item__details__date__location'>
        {location}
      </span>
      <span className='package-card__dynamic-content__wrapper__flight-list__records__item__details__date__datetime'>
        {formatWithMomentFormat(utcToLocal(date), DATE_KEYS.FORMAT.FLIGHT)}
      </span>
    </Flex>
  );
};

export default FlightDate;
